import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Grid2 as Grid,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../../../Style/dialogStyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import { translateLauguage } from "../../../../Function/Translate";
import { DROP_OUT_FROM_CLASS } from "../../../../Schema/Student";

import DatePickerForDialog from "../../../Include/SelecteDatePicker/DatePickerForDialog";
import moment from "moment";

export default function StudentDropOut({
  open,
  handleClose,
  setRefetch,
  editData,
  rowId,
  enrollmentTypeAction,
  stuData,
  dataStuAttended
}) {

  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //======================== change class =========================
  const [dropFromClass] = useMutation(DROP_OUT_FROM_CLASS, {
    onCompleted: ({ dropFromClass }) => {
      setLoading(false);
      if (dropFromClass?.is_success === true) {
        setAlert(true, "success", dropFromClass?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", dropFromClass?.message);
        console.log("error", dropFromClass?.message)
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      console.log("error", error)
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    is_drop_out: Yup.string().required(t("require")),
    drop_out_date: Yup.date().required(t("require")),
  });

  const formik = useFormik({
    initialValues: {
      is_drop_out: true,
      drop_out_date: moment(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      dropFromClass({
        variables: {
          // id: editData?._id ? editData?._id : rowId,
          id: enrollmentTypeAction === "student_page" ? rowId 
                : enrollmentTypeAction === "att_page" ? stuData?.class_attended?._id 
                : enrollmentTypeAction === "view_att_page" ? dataStuAttended 
                : editData?._id,
          input: {
            drop_out_date:
              values?.is_drop_out === false ? null : values?.drop_out_date,
            is_drop_out: values?.is_drop_out,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    setFieldValue("drop_out_date", editData?.drop_out_date ?? moment());
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("dialog_title_drop_out")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("thead_status")}
                </Typography>
                <FormControl size="small" fullWidth>
                  <Select
                    value={values?.is_drop_out}
                    onChange={(e) =>
                      setFieldValue("is_drop_out", e.target.value)
                    }
                  >
                    <MenuItem value={false}>{t("studying")}</MenuItem>
                    <MenuItem value={true}>{t("drop_out")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("drop_out_date")}
                </Typography>
                <DatePickerForDialog
                  date={values?.drop_out_date}
                  setDate={(e) => setFieldValue("drop_out_date", e)}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            // disabled={values?.is_drop_out === false ? true : false}
            >
              {t("drop_out")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
